module.exports = __webpack_public_path__ + "img/dark.0aa93717.svg";